// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TicketEntityMapper from "../entitiy-mapper/TicketEntityMapper.bs.js";
import * as TicketsStateMapper from "../entitiy-mapper/TicketsStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

function execute(data) {
  return TicketsStateMapper.TicketsInfoStateMapper.execute(data);
}

var TicketsInfoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var TicketsInfoResponseConverter = partial_arg(TicketsInfoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$1(data) {
  return TicketsStateMapper.TicketIssueStateMapper.execute(data);
}

var TicketsIssuesConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var TicketsIssuesResponseConverter = partial_arg$1(TicketsIssuesConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$2(data) {
  return TicketsStateMapper.TicketActionStateMapper.execute(data);
}

var TicketsActionsConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var TicketsActionsResponseConverter = partial_arg$2(TicketsActionsConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(data) {
  return TicketsStateMapper.TicketRequestResponseStateMapper.execute(data);
}

var TicketResponseConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var TicketRequestResponseConverter = partial_arg$3(TicketResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$4(data) {
  return TicketsStateMapper.UpdateTicketRequestResponseStateMapper.execute(data);
}

var UpdateTicketResponseConfig = {
  execute: execute$4
};

var partial_arg$4 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateTicketRequestResponseConverter = partial_arg$4(UpdateTicketResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$5(data) {
  return TicketsStateMapper.TicketsResponseMapper.execute(data);
}

var TicketsRepoConfig = {
  execute: execute$5
};

var partial_arg$5 = ResponseHandler$Catalyst.ResponseConverter;

var TicketsResponseConverter = partial_arg$5(TicketsRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$6 = TicketEntityMapper.execute;

var TicketRepoConfig = {
  execute: execute$6
};

var partial_arg$6 = ResponseHandler$Catalyst.ResponseConverter;

var TicketResponseConverter = partial_arg$6(TicketRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  TicketsInfoConfig ,
  TicketsInfoResponseConverter ,
  TicketsIssuesConfig ,
  TicketsIssuesResponseConverter ,
  TicketsActionsConfig ,
  TicketsActionsResponseConverter ,
  TicketResponseConfig ,
  TicketRequestResponseConverter ,
  UpdateTicketResponseConfig ,
  UpdateTicketRequestResponseConverter ,
  TicketsRepoConfig ,
  TicketsResponseConverter ,
  TicketRepoConfig ,
  TicketResponseConverter ,
  
}
/* TicketsInfoResponseConverter Not a pure module */
